 
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirebaseApp } from "../../config/firebase/firebaseClient";
 
const functions = getFunctions(getFirebaseApp());  

 
export const calllistbetsfortesting = async (data) => {
  try {
    const listbetsfortesting = httpsCallable(functions, "listbetsfortesting");
    const result = await listbetsfortesting(data);
    return result.data;
  } catch (error) {
    console.error("Error calling listbetsfortesting function:", error);
    throw error;
  }
};
export const callAcceptrandomusersforbet = async (data) => {
  try {
    const acceptrandomusersforbet = httpsCallable(functions, "acceptrandomusersforbet");
    const result = await acceptrandomusersforbet(data);
    return result.data;
  } catch (error) {
    console.error("Error calling acceptrandomusersforbet function:", error);
    throw error;
  }
};
export const callGetcompletedbettestsummary = async (data) => {
  try {
    const getcompletedbettestsummary = httpsCallable(functions, "getcompletedbettestsummary");
    const result = await getcompletedbettestsummary(data);
    return result.data;
  } catch (error) {
    console.error("Error calling getcompletedbettestsummary function:", error);
    throw error;
  }
};